// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"SearchBox_searchBox__4Bu8F","searchIcon":"SearchBox_searchIcon__1KMA4","searchInput":"SearchBox_searchInput__16soB"};